import React from 'react';
import {
    Alert,
    Avatar,
    List,
    ListItem,
    ListItemAvatar,
    ListItemButton,
    ListItemText,
    Stack,
    Typography
} from "@mui/material";
import SendMessageButton from "../../../../../components/SendMessageButton";
import {useSession} from "../../../../../firebase/UserProvider";
import {resolveExpertAvatarUrl} from '../../../../../utils/expertAvatar';
const experts = [
    {
        uid: 'lw8qu6X8kiWWQOvIkEnSzYYW4Kk2',
        name: 'Dana Scully',
        email: 'dana.scully@x-files.com',
        password: '41234123',
        position: 'Analyst',
        headshot: '/assets/dana.jpg',
        isAvailable: true,
    },
    {
        uid: 'BV1KHailTbZx2Qk3vTu0hxbS37o2',
        name: 'Fox Mulder',
        email: 'fox.mulder@x-files.com',
        password: '41234123',
        position: 'Analyst',
        headshot: '/assets/fox.jpg',
        isAvailable: true,
    },
];

/**
 * Displays a group of topics with optional expert suggestions
 */
const TopicGroup = ({title, color, items = [], customSx = {}, suggestExperts = false, showEmpty = false}) => {
    const {user} = useSession();

    // If no items and showEmpty is false, don't render anything
    if ((!items || items.length === 0) && !showEmpty) return null;

    return (
        <Stack spacing={0.5}>
            <Typography variant="caption" fontWeight={600} color="text.secondary">{title}</Typography>

            {(!items || items.length === 0) ? (
                <Alert severity={color} icon={false} sx={{p: 1.5, ...customSx}}>
                    <Typography variant="body2" color="text.secondary" fontStyle="italic">
                        None found
                    </Typography>
                </Alert>
            ) : (
                <Stack spacing={0.5}>
                    {items.map((t, idx) => (
                        <Alert key={`${title}-${idx}`} severity={color} icon={false} sx={{p: 0, ...customSx}}>
                            <Stack p={2} pt={1} spacing={1}>
                                <Typography variant="body1" fontWeight={600}>{t.tag}</Typography>
                                {t.comment && (
                                    <Typography variant="body2" color="text.secondary">{t.comment}</Typography>
                                )}
                            </Stack>

                            {suggestExperts && (
                                <>
                                    <Typography variant="body2" sx={{px: 2, pb: 1}}>
                                        Suggested experts
                                    </Typography>

                                    <List disablePadding>
                                        {experts.map((e) => {
                                            if (user.uid === e.uid) return null;
                                            const id = e?.uid;
                                            const avatarSrc = resolveExpertAvatarUrl(e);
                                            const secondary = e?.email;

                                            return (
                                                <ListItem
                                                    key={id}
                                                    alignItems="flex-start"
                                                    disablePadding
                                                    secondaryAction={
                                                        <SendMessageButton
                                                            isIcon={true}
                                                            user={{
                                                                userDisplayName: e.name,
                                                                displayName: e.name,
                                                                headshot: e.headshot,
                                                                agency: e.agency,
                                                                office: e.office,
                                                                poc: e.poc,
                                                                contact: e.contact,
                                                                title: e.userTitle,
                                                                email: e.email,
                                                                uid: e.uid,
                                                            }}
                                                        />
                                                    }
                                                >
                                                    <ListItemButton
                                                        onClick={() => {
                                                            const name = e?.name || '';
                                                            const slug = encodeURIComponent(name.toLowerCase().trim().replace(/\s+/g, '.'));
                                                            window.open(`/experts/${slug}`, '_blank', 'noopener,noreferrer');
                                                        }}
                                                    >
                                                        <ListItemAvatar>
                                                            <Avatar src={avatarSrc}/>
                                                        </ListItemAvatar>
                                                        <ListItemText
                                                            primary={e.name}
                                                            secondary={secondary}
                                                        />
                                                    </ListItemButton>
                                                </ListItem>
                                            );
                                        })}
                                    </List>
                                </>
                            )}
                        </Alert>
                    ))}
                </Stack>
            )}
        </Stack>
    );
};

export default TopicGroup;
